
//Obtiene un candy por su strMCode.
export function GetCandy(JsonCandys, strMCode, strBarcode) {
    return JsonCandys.reduce((foundCandy, category) => {
        if (!foundCandy) {
            foundCandy = category.Candys.find(t =>
                t.strMCode === strMCode &&
                (
                    (strBarcode === undefined && t.strBarcode === undefined) ||
                    (strBarcode === null && (t.strBarcode === null || t.strBarcode === undefined)) ||
                    (strBarcode !== undefined && t.strBarcode === strBarcode)
                )
            );
        }
        return foundCandy;
    }, null);
}


//Obtiene un option de un candy por su intRecogId y intPromoId.
export function GetOption(TicketCandy, intRecogId, intPromoId) {
    var option = TicketCandy.BuyOptions.find(o => o.intRecogId == intRecogId && o.intPromoId == intPromoId);
    return option;
}

//Valido si producto tiene reglas de exclusividad
export function ValidateExclusiveProduct(ExclusiveMCodes, strMCode) {
    var mcodes = ExclusiveMCodes.split(';');

    var foundMatch = false;

    mcodes.forEach(mcode => {
        if (mcode != null && mcode != '') {
            if (mcode == strMCode) {
                foundMatch = true;
            }
        }
    });

    return foundMatch;
}

//Valido la exclusividad del Member al producto
export function ValidateLevelMemberExclusive(Member, DtmCineFan, DtmBasico) {
    var intLoyaltyLevel = Member.intLoyaltyLevel;

    //Si el member no es Cine Fan Black
    if (intLoyaltyLevel < 4) {
        // Obtener la fecha y hora actual
        var currentDate = new Date();

        // Convertir la cadena DtmCineFan a un objeto Date
        var dtmCineFanDate = new Date(DtmCineFan);

        // Convertir la cadena DtmBasico a un objeto Date
        var dtmBasicoDate = new Date(DtmBasico);

        //Si la fecha actual es menor a la fecha en la que solo pueden comprar los Cine Fan Black
        if (currentDate <= dtmCineFanDate) {
            return -1;
        }

        //Si es Basico y la fecha actual es menor a la fecha en la que solo pueden comprar los Cine Fan (Cine Fan Black, Cine Fan+ y Cine Fan)
        if (intLoyaltyLevel == 1 && currentDate <= dtmBasicoDate) {
            return -2;
        }
    }

    return 0;
}

//Crea y actualiza el carrito de candys.
export function UpdateOrder(CartCandys, strMCode, strBarcode, intRecogId, intQty, boms, intPromoId) {
    boms == 'undefined' || boms == null && (boms = []);

    var orderCandy = { strMCode: strMCode, strBarcode: strBarcode, intRecogId: intRecogId, intQty: intQty, boms: boms, intPromoId: intPromoId };
    var estaba = false;
    var removeItemIndex = -1;
    if (CartCandys != null) {
        //if (orderCandy.boms.length == 0 || orderCandy.intQty < 0) {
            CartCandys.forEach(orderItem => {
                if ((orderItem.strMCode == orderCandy.strMCode) && (orderItem.strBarcode == orderCandy.strBarcode) && (orderItem.intRecogId == orderCandy.intRecogId) && (orderItem.intPromoId == orderCandy.intPromoId) && !estaba && ObjectEquals(orderItem.boms, orderCandy.boms)) {
                    estaba = true;
                    orderItem.intQty = orderItem.intQty + orderCandy.intQty;
                    orderItem.intQty == 0 && (removeItemIndex = CartCandys.indexOf(orderItem));
                }
            });
            removeItemIndex !== -1 && CartCandys.splice(removeItemIndex, 1);
        //}
    } else {
        CartCandys = [];
    }

    if (estaba == false) {
        if (orderCandy.intQty > 0) {
            CartCandys.push(orderCandy);
        }
    }

    return CartCandys;
}


//Retorna la cantidad de Candys totales o por un strMCode, strBarcode, intRecogId y intPromoId.
export function GetQty(JsonCandys, CartCandys, strMCode, strBarcode, intRecogId, intPromoId) {
    if (CartCandys == null)
        return 0;

    var intQty = 0;

    CartCandys.forEach(orderItem => {
        if (!StringIsNullOrEmpty(strMCode)) {
            if (orderItem.strMCode == strMCode && orderItem.strBarcode == strBarcode && orderItem.intRecogId == intRecogId && orderItem.intPromoId == intPromoId) {
                intQty = intQty + orderItem.intQty;
            }
        }
        else {
            intQty = intQty + orderItem.intQty;
        }
    });

    return intQty;
}

//Retorno un string con el Subtotal de la Orden
export function GetStringSubtotalValue(JsonCandys, CartCandys, total_tickets_value) {
    if (CartCandys == null)
        return '$0';

    var totalPrice = 0;

    CartCandys.forEach(orderItem => {
        var ticket = GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = GetOption(ticket, orderItem.intRecogId, orderItem.intPromoId);
        orderItem.boms.forEach(b => {
            b.Options.forEach(option => {
                totalPrice = totalPrice + ((option.intQty * option.intPrice) * orderItem.intQty);
            })
        })

        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
    });

    var price = ((totalPrice + total_tickets_value) / 100).toLocaleString('es-AR');
    var result = "$" + price;

    return result;
}

//Retorno un string con el ServiceCharge
export function GetStringCandysServiceValue(JsonCandys, CartCandys, TotalService, DefaultService) {
    // Control para nsMerchandising.aspx
    if ((DefaultService == 0) && (TotalService > 0))
        return "$" + (TotalService / 100).toLocaleString('es-AR');

    // Si el carrito esta vacio devuelvo 0
    if (CartCandys == null)
        return '$0';

    var totalPrice = 0;
    var qty = 0;

    CartCandys.forEach(orderItem => {
        var ticket = GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = GetOption(ticket, orderItem.intRecogId, orderItem.intPromoId);
        orderItem.boms.forEach(b => {
            b.Options.forEach(option => {
                totalPrice = totalPrice + ((option.intQty * option.intPrice) * orderItem.intQty);
            })
        })
        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
        qty = qty + 1;
    });

    if (totalPrice > 0)
        var price = (DefaultService / 100).toLocaleString('es-AR');
    else
        price = 0;

    var result = "$" + price;
    return result;
}

//Devuelte el strTitle del primer ticket que se encuentre para onlyBuy.
export function FirsItemOnlyBuy(JsonCandys, CartCandys) {
    if (CartCandys == null || CartCandys.length == 0) {
        return '';
    }
    var result = "";
    CartCandys.forEach(item => {
        var candy = GetCandy(JsonCandys, item.strMCode, item.strBarcode);

        if (candy.bitOnlyBook) {
            result = candy.strTitle;
        }
    });
    return result;
}

function StringIsNullOrEmpty(value) {
    return !(typeof value === "string" && value.length > 0);
}


function ObjectEquals(x, y) {
    if (x === y) return true;

    if (!(x instanceof Object) || !(y instanceof Object)) return false;

    if (x.constructor !== y.constructor) return false;

    for (var p in x) {
        if (!x.hasOwnProperty(p)) continue;

        if (!y.hasOwnProperty(p)) return false;

        if (x[p] === y[p]) continue;

        if (typeof (x[p]) !== "object") return false;

        if (!ObjectEquals(x[p], y[p])) return false;
    }

    for (p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
    }
    return true;
}

export function GetTotalValue(JsonCandys, CartCandys) {
    if (CartCandys == null)
        return 0;

    var totalPrice = 0;
    CartCandys.forEach(orderItem => {
        var ticket = GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = GetOption(ticket, orderItem.intRecogId, orderItem.intPromoId);
        orderItem.boms.forEach(b => {
            b.Options.forEach(option => {
                totalPrice = totalPrice + ((option.intQty * option.intPrice) * orderItem.intQty);
            })
        })
        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
    });
    var price = totalPrice / 100;

    return price;
}

//Valida codigo de voucher, no vacio y longitud.
export function VoucherValidate() {
    var expreg = new RegExp($('#txtVoucherCode')[0].pattern);
    return expreg.test($('#txtVoucherCode').val());
}


// WEBPACK FOOTER //
// ./src/functionsCandys.js